import React, { createContext, useContext, useState } from "react";

const NavbarContext = createContext<{
  navBarData: any;
  setnavBarData: (s:any) => void;
}>({
  navBarData: {},
  setnavBarData: (...arg:any) => {},
});

export const useNavbar = () => useContext(NavbarContext);

export const NavbarProvider = ({ children }: { children: React.ReactNode }) => {
  const [navBarData, setnavBarData] = useState({});
  return (
    <NavbarContext.Provider value={{ navBarData, setnavBarData }}>
      {children}
    </NavbarContext.Provider>
  );
};
